<template>
  <div
    class="vmp-insert-stream"
    @mouseenter="wrapHover"
    @mouseleave="wrapLeave"
    v-show="insertFileStreamVisible || !isWatch"
    ref="insertWrapRef"
    :class="{
      'vmp-insert-stream__h0': !insertFileStreamVisible,
      'vmp-insert-stream__mini':
        (miniElement == 'insert-video' || miniElement == 'stream-list') && insertFileStreamVisible,
      'vmp-insert-stream__is-watch': isWatch,
      'vmp-insert-stream__is-embed': isEmbed,
      'vmp-insert-stream__has-stream-list': hasStreamList,
      'vmp-insert-stream__is-watch-full-screen': isWatch && isFullScreen
    }"
  >
    <div class="vmp-insert-stream-mask" v-if="!['SplitScreen'].includes($route.name)">
      <p>
        <span v-show="!isWatch" class="vmp-insert-stream-mask__label">
          {{ $t('host.k_545001') }}
        </span>
        <vh-tooltip
          :content="$t('host.k_545002')"
          placement="top"
          v-if="!isFullScreen && (!isWatch || (isWatch && docSwitchStatus))"
        >
          <a
            href="javascript:void(0);"
            class="vh-iconfont vh-line-copy-document"
            @click="exchange"
          ></a>
        </vh-tooltip>
        <vh-tooltip :content="$t('host.k_545003')" placement="top">
          <a
            v-if="!isFullScreen"
            href="javascript:void(0);"
            class="vh-iconfont vh-line-amplification"
            @click="enterFullScreen"
          ></a>
          <a
            v-if="isFullScreen"
            href="javascript:void(0);"
            class="vh-iconfont vh-line-narrow"
            @click="exitFullScreen"
          ></a>
        </vh-tooltip>
      </p>
    </div>
    <!-- 本地互动流的显示容器 -->
    <div id="vmp-insert-local-stream" ref="localStreamRef" class="vmp-insert-local-stream"></div>

    <!-- 远端互动流的显示容器 订阅流 -->
    <div
      id="vmp-insert-subscribe-stream"
      ref="remoteStreamRef"
      class="vmp-insert-subscribe-stream"
      v-show="!isCurrentRoleInsert"
    ></div>

    <!-- 本地视频插播的video容器 -->
    <div
      id="vmp-insert-stream-video"
      class="vmp-insert-stream-video"
      v-show="insertFileType == 'local' && isCurrentRoleInsert"
      :style="{ height: isAudio ? '0px' : '100%' }"
    ></div>

    <!-- 音频插播封面图 -->
    <div
      v-if="isAudio && ((isLiving && isFullScreen) || !isLiving || mode == 1)"
      class="vmp-insert-stream-audio-poster"
    ></div>

    <!-- 远端视频插播的播放器容器 -->
    <div
      id="vmp-insert-remote-stream"
      class="vmp-insert-remote-stream"
      v-if="!['SplitScreen'].includes($route.name)"
    >
      <video-preview
        ref="insertStream"
        scene="insert"
        :videoParam="remoteVideoParam"
        :curInsertParams="curInsertParams"
        :isInsertVideoPreview="true"
        :insertPlayType="curInsertPlayType"
        :isShowController="miniElement != 'insert-video'"
        @remoteInsertSuccess="remoteInsertSuccess"
        @openInsert="handleOpenInsertFileDialog"
        @handleRemoteInsertVideoPlay="handleRemoteInsertVideoPlay"
        @handleRemoteInsertVideoPause="handleRemoteInsertVideoPause"
        @closeInsertvideo="closeInsertvideo({ type: 'remote' })"
        @insertVideoEnd="insertVideoEnd"
        @changeInsertVideoType="handleCommand"
        v-if="insertFileType == 'remote' && isCurrentRoleInsert"
      ></video-preview>
    </div>

    <!-- 播放器控制条 -->
    <div
      v-show="insertFileType == 'local' && isCurrentRoleInsert && miniElement != 'insert-video'"
      class="vmp-insert-stream-controller"
      :class="{ 'insert-active-top': constrolUp }"
    >
      <div class="vmp-insert-stream-controller-slider">
        <vh-slider
          ref="controllerRef"
          v-model="conctorObj.sliderVal"
          :show-tooltip="false"
          @change="setVideoCurrentTime"
        ></vh-slider>
        <div
          v-show="conctorObj.TimesShow"
          class="vmp-insert-stream-controller-slider-times"
          :style="{ left: conctorObj.hoverLeft + 'px' }"
        >
          <span>{{ conctorObj.hoverTime | secondToDate }}</span>
        </div>
      </div>
      <div class="vmp-insert-stream-controller-wrap">
        <div class="vmp-insert-stream-controller-wrap-left">
          <i
            ref="videoPlayBtnDom"
            class="vh-iconfont"
            @click="videoPlayBtn"
            :class="conctorObj.statePlay ? 'vh-a-line-videopause' : 'vh-line-video-play'"
          ></i>
          <div class="vmp-insert-time">
            <span>{{ conctorObj.currentTime | secondToDate }}</span>
            <span>/</span>
            <span>{{ conctorObj.totalTime | secondToDate }}</span>
          </div>
        </div>
        <div class="vmp-insert-stream-controller-wrap-right">
          <div class="vmp-volume-box">
            <span class="vmp-icon-box">
              <i
                class="vh-iconfont"
                :class="voice > 1 ? 'vh-line-voice' : 'vh-line-mute'"
                @click="videoMute"
              ></i>
            </span>
            <div class="vmp-ver-slider">
              <vh-slider
                v-model="voice"
                vertical
                height="100px"
                @change="setVoice"
                :show-tooltip="true"
              ></vh-slider>
            </div>
          </div>
          <vh-dropdown @command="handleCommand" placement="top" trigger="click">
            <span class="vh-dropdown-link">
              <vh-tooltip class="item" effect="dark" :content="$t('host.k_545004')">
                <span v-show="curInsertPlayType == 1" class="iconfont-v3 saasline-video"></span>
              </vh-tooltip>
              <vh-tooltip class="item" effect="dark" :content="$t('host.k_545005')">
                <span
                  v-show="curInsertPlayType == 2"
                  class="iconfont-v3 saasa-line-radiolist"
                ></span>
              </vh-tooltip>
              <vh-tooltip class="item" effect="dark" :content="$t('host.k_545006')">
                <span
                  v-show="curInsertPlayType == 3"
                  class="iconfont-v3 saasa-line-playcycle"
                ></span>
              </vh-tooltip>
            </span>
            <vh-dropdown-menu slot="dropdown" class="dropdownVideo insertDropdownVideo">
              <vh-dropdown-item :command="1">
                <span class="iconfont-v3 saasline-video"></span>
                {{ $t('host.k_545004') }}
              </vh-dropdown-item>
              <vh-dropdown-item :command="2">
                <span class="iconfont-v3 saasa-line-radiolist"></span>
                {{ $t('host.k_545005') }}
              </vh-dropdown-item>
              <vh-dropdown-item :command="3">
                <span class="iconfont-v3 saasa-line-playcycle"></span>
                {{ $t('host.k_545006') }}
              </vh-dropdown-item>
            </vh-dropdown-menu>
          </vh-dropdown>
          <vh-tooltip effect="dark" :content="$t('host.k_545007')">
            <i @click="handleOpenInsertFileDialog" class="vh-iconfont vh-line-menu"></i>
          </vh-tooltip>
          <vh-tooltip effect="dark" :content="$t('host.k_545008')">
            <i
              @click="
                closeInsertvideo({
                  isShowConfirmDialog: true,
                  type: 'btn_close'
                })
              "
              class="vh-iconfont vh-line-close"
            ></i>
          </vh-tooltip>
          <vh-tooltip effect="dark" :content="$t('host.k_545009')">
            <i @click="hideInsertVideoControl" class="vh-iconfont vh-line-arrow-down"></i>
          </vh-tooltip>
        </div>
      </div>
    </div>
    <vmp-air-container
      v-if="childrenCom && childrenCom.length"
      :oneself="true"
      :cuid="childrenCom[0]"
    ></vmp-air-container>
  </div>
</template>
<script>
  import videoPreview from '@/app-shared/components/video-preview';
  import {
    useInsertFileServer,
    useRoomBaseServer,
    useInteractiveServer,
    useGroupServer,
    useMsgServer,
    useMicServer,
    useDocServer
  } from 'middle-domain';
  import { boxEventOpitons } from '@/app-shared/utils/tool.js';
  export default {
    name: 'VmpInsertStream',
    data() {
      return {
        childrenCom: [],
        insertFileStreamVisible: false, // 是否展示插播流组件
        // 云插播文件参数
        remoteVideoParam: {
          paas_record_id: '',
          file_type: '',
          autoplay: true
        },
        constrolUp: false, // 控制栏显示、隐藏
        // 控制栏信息
        conctorObj: {
          TimesShow: false,
          hoverTime: 0,
          hoverLeft: 0,
          totalTime: 1,
          currentTime: 0,
          sliderVal: 0,
          statePlay: false
        },
        // 本地插播音量
        voice: 100,
        // 本地插播全屏
        isFullScreen: false,
        curInsertPlayType: 1, //播放方式
        curInsertParams: null //插播参数
      };
    },
    computed: {
      // 是否观看端
      isWatch() {
        return !['send', 'record', 'clientEmbed'].includes(
          this.$domainStore.state.roomBaseServer.clientType
        );
      },
      // 是否嵌入
      isEmbed() {
        return this.$domainStore.state.roomBaseServer.embedObj.embed;
      },
      docSwitchStatus() {
        return this.$domainStore.state.docServer.switchStatus;
      },
      // 云插播 remote 本地插播 local
      insertFileType() {
        return this.$domainStore.state.insertFileServer.insertFileType;
      },
      // 是否是音频插播
      isAudio() {
        return !this.$domainStore.state.insertFileServer.insertStreamInfo.has_video;
      },
      // 是否是当前用户插播
      isCurrentRoleInsert() {
        return (
          // 当前正在插播，插播人id等于当前用户id
          this.$domainStore.state.insertFileServer.isInsertFilePushing &&
          this.$domainStore.state.insertFileServer.insertStreamInfo.userInfo.accountId ==
            this.$domainStore.state.roomBaseServer.watchInitData.join_info.third_party_user_id
        );
      },
      mode() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.mode;
      },
      isLiving() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
      },
      miniElement() {
        return this.$domainStore.state.roomBaseServer.miniElement;
      },
      // 互动是否初始化完成
      isInstanceInit() {
        return this.$domainStore.state.interactiveServer.isInstanceInit;
      },
      hasStreamList() {
        return this.$domainStore.state.interactiveServer.streamListHeightInWatch >= 1;
      },
      // 是否是上麦状态
      isSpeakOn() {
        return this.$domainStore.state.micServer.isSpeakOn;
      },
      // 观众是否加载了旁路播放器
      isPlayerInit() {
        const { interactiveServer, roomBaseServer, micServer } = this.$domainStore.state;
        const isNoDelay = roomBaseServer.watchInitData.webinar.no_delay_webinar == 1;
        const mode = roomBaseServer.watchInitData.webinar.mode;
        return (
          (roomBaseServer.watchInitData.join_info.role_name == 2 &&
            ((mode == 3 && (!micServer.isSpeakOn || !interactiveServer.isInstanceInit)) ||
              (mode == 2 && !isNoDelay))) ||
          interactiveServer.initInteractiveFailed
        );
      },
      // 是否开启了桌面共享
      isShareScreen() {
        return this.$domainStore.state.desktopShareServer.localDesktopStreamId;
      },
      // 桌面共享人信息
      desktopShareInfo() {
        return this.$domainStore.state.desktopShareServer.desktopShareInfo;
      },
      // 是否工具简单模式（乐乐专属）
      isLeLeInteractMode() {
        return this.$domainStore.state.roomBaseServer?.configList?.['lele_interact_model'];
      },
      // 是否直播带货模式
      isLiveCommerceMode() {
        return this.$domainStore.state.roomBaseServer?.configList?.['live_commerce_model'];
      }
    },
    watch: {
      'conctorObj.sliderVal'(val) {
        if (this.onmousedownControl) {
          this.hoverTime = (val / 100) * this.conctorObj.totalTime;
          this.hoverLeft = (val / 100) * (this.ContorlWidth || 0);
        }
      },
      '$domainStore.state.insertFileServer.currentRemoteInsertFile': {
        handler(value) {
          if (value) {
            this.remoteVideoParam.paas_record_id = value.paas_record_id;
            this.remoteVideoParam.file_type = value.file_type;
          }
        }
      },
      '$domainStore.state.insertFileServer.isInsertFilePushing': {
        handler() {
          this.insertFileStreamVisible =
            this.$domainStore.state.insertFileServer.isInsertFilePushing;
        }
      },
      // 主讲人切换，关闭插播
      '$domainStore.state.roomBaseServer.interactToolStatus.doc_permission': {
        handler() {
          if (
            this.isCurrentRoleInsert &&
            this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name != 3
          ) {
            this.closeInsertvideoHandler();
          }
        }
      },
      insertFileStreamVisible(val, oldVal) {
        if (oldVal && !val && this.isFullScreen) {
          this.autpExitFullscreen();
        }
      },
      isInstanceInit(val, oldVal) {
        if (oldVal && !val && this.isFullScreen) {
          this.autpExitFullscreen();
        }
      }
    },
    components: { videoPreview },
    beforeCreate() {
      this.interactiveServer = useInteractiveServer();
      this.msgServer = useMsgServer();
      this.roomBaseServer = useRoomBaseServer();
      this.insertFileServer = useInsertFileServer();
      this.docServer = useDocServer();
    },
    created() {
      // 收到PC看端[固定大小屏切换按钮]点击消息处理
      this.$emitter.on(this.$EMIT_DEFINE.max_min_screen_exchange, this.handleScreenExchange);

      this.childrenCom = window.$serverConfig[this.cuid].children;
    },
    mounted() {
      this.initEventListener();
    },
    beforeDestroy() {
      this.$emitter.off(this.$EMIT_DEFINE.max_min_screen_exchange, this.handleScreenExchange);
    },
    destroyed() {
      this.insertFileServer.$off('INSERT_FILE_STREAM_ADD');
    },
    methods: {
      // 自动退出全屏
      autpExitFullscreen() {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
        else if (document.msExitFullscreen) document.msExitFullscreen();
      },
      // 开始插播的入口
      async startInertFile() {
        const { watchInitData } = useRoomBaseServer().state;
        // 展示插播流组件
        this.insertFileStreamVisible = true;
        // 设置插播状态为 true
        this.insertFileServer.setInsertFilePushing(true);
        this.insertFileServer.state.insertStreamInfo.userInfo = {
          // 推插播流的人的信息
          accountId: watchInitData.join_info.third_party_user_id,
          role: watchInitData.join_info.role_name,
          nickname: watchInitData.join_info.nickname
        };
        if (this.insertFileType === 'local') {
          // 本地插播
          this.initLocalInsertFile();
        } else {
          // 云插播
          window.vhallReportForProduct?.toReport(110199, { report_extra: { file_info: '' } });
          this.initRemoteInsertFile();
        }
      },
      // 检测当前用户是否可以插播
      checkInsertFileProcess() {
        if (this.isLeLeInteractMode || this.isLiveCommerceMode) return false;
        const { watchInitData } = useRoomBaseServer().state;
        const { isInsertFilePushing, insertStreamInfo } = this.insertFileServer.state;
        console.log('---点击插播文件-确定按钮----', insertStreamInfo);

        // 如果是直播状态需要判断当前主持人是否是用网页发起直播
        // 嘉宾：设为主讲人的时候 可以插播
        // 助理： 如果是网页发起，一直都有插播。如果是客户端发起，不支持插播文件，存在提示
        if (
          watchInitData.switch.start_type != 1 &&
          watchInitData.webinar.type == 1 &&
          watchInitData.join_info.role_name == 3
        ) {
          this.$vhAlert(this.$t('host.k_545010'), '', {
            title: this.$t('host.k_545011'),
            confirmButtonText: this.$t('host.k_545012'),
            roundButton: true
          });
          return false;
        }
        // 如果在插播中，并且不是当前用户插播，alert提示
        if (
          isInsertFilePushing &&
          insertStreamInfo.userInfo.accountId != watchInitData.join_info.third_party_user_id
        ) {
          this.$vhAlert(
            this.$t('host.k_545013', [
              this.$getRoleName(insertStreamInfo.userInfo.role),
              insertStreamInfo.userInfo.role != 1 ? insertStreamInfo.userInfo.nickname : ''
            ]),

            '',
            {
              title: this.$t('host.k_545011'),
              confirmButtonText: this.$t('host.k_545014'),
              roundButton: true
            }
          );
          return false;
        }
        // 判断该当前浏览器是否支持插播
        if (!this.insertFileServer.isCanUseCaptureStream()) {
          this.$vhAlert(
            this.$t('host.k_545015'),

            '',
            {
              title: this.$t('host.k_545011'),
              confirmButtonText: this.$t('host.k_545012'),
              roundButton: true,
              dangerouslyUseHTMLString: true,
              callback: () => {}
            }
          );
          return false;
        }
        return true;
      },
      // 插播文件更改
      async inertFileChange(video, type, curInsertPlayType = 1, params) {
        // this.curInsertPlayType = curInsertPlayType;
        if (params) {
          this.curInsertParams = params;
          // this.curInsertPlayType = params.curInsertPlayType;
        }

        const { watchInitData } = useRoomBaseServer().state;
        // 他人正在演示插播，当前不可操作；有人正在桌面共享，当前不可插播
        if (!this.checkInsertFileProcess() || this.isShareScreen || watchInitData.rebroadcast?.id) {
          if (this.isShareScreen && this.desktopShareInfo) {
            // 当前有桌面共享，并且桌面共享演示人信息能获取的时候
            this.$vhAlert(
              this.$t('host.k_545016', [
                this.$getRoleName(this.desktopShareInfo.role),
                this.desktopShareInfo.role != 1 ? this.desktopShareInfo.nickname : ''
              ]),

              '',
              {
                title: this.$t('host.k_545011'),
                confirmButtonText: this.$t('host.k_545014'),
                roundButton: true
              }
            );
          }
          if (watchInitData.rebroadcast?.id) {
            this.$message.warning(this.$t('host.k_545017'));
          }
          // 当前不可演示插播, 关闭插播列表弹窗
          window.$middleEventSdk?.event?.send(
            boxEventOpitons(this.cuid, 'emitCloseInsertFileDialog')
          );
          return;
        }
        // 如果当前正在插播中，需要先结束现有插播
        if (this.insertFileServer.state.isInsertFilePushing && (!params || !params.jumpCheck)) {
          await this.closeInsertvideoHandler();
        } else if (params && params.jumpCheck) {
          if (this.conctorObj.statePlay) {
            // 如果不是暂停状态，关闭插播时会触发暂停事件，记录这个状态，暂停事件不需要发自定义消息
            this._isCloseInsertvideoHandler = true;
          }
          window.vhallReportForProduct.toStartReporting(110210, 110211);
          let res = await this.stopPushStream();
          window.vhallReportForProduct.toResultsReporting(110211, {
            request_id: res?.request_id,
            event_type: 'interface',
            res: res
          });
          console.log('---插播流停止成功----');
        }
        // 更新选择插播的文件
        this.insertFileServer.setInsertFileType(type);
        if (type == 'local') {
          this.insertFileServer.setLocalInsertFile(video);
        } else {
          this.insertFileServer.setRemoteInsertFile(video);
          // 延迟一下，否则watch currentRemoteInsertFile更新不及时, 会导致顺序播放的视频还是上一个
          await this.$nextTick();
        }
        this.startInertFile();
      },
      // 初始化本地插播,创建video标签播放本地文件
      async initLocalInsertFile() {
        this._videoEnded = false; // 本地插播文件是否播放结束
        this._isFirstInsertSucces = true; // 记录开始本地插播的状态，video play事件会用到
        if (this.insertFileServer.state.insertStreamInfo.streamId) {
          await this.stopPushStream();
        }
        // 创建video标签播放本地音视频文件
        this.insertFileServer
          .createLocalVideoElement(this.insertFileServer.currentLocalInsertFile, {
            el: 'vmp-insert-stream-video'
          })
          .then(videoElement => {
            // video创建成功，初始化
            this.handleLocalInsertVideoCreated(videoElement);
          })
          .catch(err => {
            console.log('初始化本地插播播放器失败', err);
            this.$message.warning(this.$t('host.k_545018'));
            // 关闭插播，传 ture 不需要更改麦克风状态
            this.closeInsertvideoHandler(true);
          });
      },
      // 本地插播，video成功创建之后的处理逻辑
      handleLocalInsertVideoCreated(videoElement) {
        // 设置插播画面在大窗,文档在小窗
        this.roomBaseServer.setChangeElement('doc');
        // 隐藏分组设置
        const groupServer = useGroupServer();
        groupServer.state.panelShow = false;
        // 保存当前正在播放的videoElement对象，后续播放、暂停、设置事件等需要用到
        this._localFileVideoElement = videoElement;
        // 事件监听 暂停，播放，播放完成
        this.InitVideoEvent();
        // 关闭插播列表弹窗
        window.$middleEventSdk?.event?.send(
          boxEventOpitons(this.cuid, 'emitCloseInsertFileDialog')
        );
        this.initSlider(); // 初始化播放器控件
        this.play();
        window.vhallReportForProduct?.toReport(110218);
        this.pushLocalStream(); // 推流
      },
      // 创建本地插播流
      createLocalStream() {
        return new Promise((resolve, reject) => {
          this.insertFileServer
            .createLocalInsertStream({
              videoNode: 'vmp-insert-local-stream',
              videoContentHint: sessionStorage.getItem('videoHint') || 'detail'
            })
            .then(e => {
              console.log('创建插播本地流成功');
              resolve(e);
              // 并开始推送互动流
            })
            .catch(() => {
              console.log('创建插播本地流失败');
              this.closeInsertvideo({
                isShowConfirmDialog: false,
                type: 'created_field'
              });
              reject(new Error(this.$t('host.k_545019')));
              this.$message.warning(this.$t('host.k_545020'));
            });
        });
      },
      // 推流
      async pushLocalStream() {
        // const interactiveServer = useInteractiveServer();
        const { watchInitData } = useRoomBaseServer().state;
        // 如果未开播，不推流
        if (watchInitData.webinar.type != 1) return;

        const res = await this.createLocalStream();
        this.insertFileServer
          .publishInsertStream({ streamId: res.streamId })
          .then(() => {
            // 更改麦克风状态
            this.insertFileServer.updateMicMuteStatusByInsert({ isStart: true });
            // 设置旁路观看端大小屏
            this.setDesktop('1');
          })
          .catch(() => {
            this.$message.warning(this.$t('host.k_545021'));
          });
      },
      // 云插播播放器开始播放
      handleRemoteInsertVideoPlay(isVideoEnd) {
        if (isVideoEnd) {
          // 如果是结束播放，重新开始播放，需要重新推流
          this.stopPushStream({ isNotClearInsertFileInfo: true }).then(() => {
            // TODO: 这里添加延时器，是为了降低后端两个异步任务顺序不对的问题出现的概率。
            // 临时解决方案，后端解决周期较长，待后端处理完成之后去掉即可。
            setTimeout(() => {
              this.pushLocalStream();
            }, 1000);
          });
        } else {
          // 如果是播放结束重新开始播放，对端会通过流加入时间更改上麦人员麦克风状态，不需要发消息
          // 发送自定义消息，通知开始插播，互动角色关闭麦克风
          this.insertFileServer.sendStateChangeMessage(1);
        }
      },
      // 云插播播放器暂停播放
      handleRemoteInsertVideoPause() {
        // 发送自定义消息，通知插播暂停，互动角色开启麦克风
        this.insertFileServer.sendStateChangeMessage(0);
      },
      // 添加播放器video事件
      InitVideoEvent() {
        // 本地插播
        this._localFileVideoElement.addEventListener('ended', () => {
          this._videoEnded = true;

          if (this.curInsertPlayType == 3) {
            //单视频循环播放
            this.play();
          }
        });
        // 本地插播播放器播放事件
        this._localFileVideoElement.addEventListener('play', () => {
          console.log(this._videoEnded, 'play');
          this.conctorObj.statePlay = true;
          // 如果是结束播放，重新开始播放，需要重新推流
          if (this._videoEnded) {
            this._videoEnded = false;
            // 播放结束之后的重新播放，观看端根据流加入事件静音麦克风，不需要发消息，所以置为 true
            this._isFirstInsertSucces = true;
            this.stopPushStream({ isNotClearInsertFileInfo: true }).then(() => {
              // TODO: 这里添加延时器，是为了降低后端两个异步任务顺序不对的问题出现的概率。
              // 临时解决方案，后端解决周期较长，待后端处理完成之后去掉即可。
              setTimeout(() => {
                this.pushLocalStream();
              }, 1000);
            });
          }
          // 发送自定义消息，通知开始插播，互动角色关闭麦克风
          // 如果是插播由 暂停 ——> 开始，才需要发自定义消息
          if (this._isFirstInsertSucces) {
            this._isFirstInsertSucces = false;
            return;
          }
          this.insertFileServer.sendStateChangeMessage(1);
        });
        // 本地插播播放器暂停事件
        this._localFileVideoElement.addEventListener('pause', () => {
          console.log('暂停了啊');
          this.conctorObj.statePlay = false;
          // 如果不是关闭触发的暂停，发送自定义消息，通知插播暂停，互动角色开启麦克风
          if (!this._isCloseInsertvideoHandler) {
            this.insertFileServer.sendStateChangeMessage(0);
            return;
          }
          this._isCloseInsertvideoHandler = false;
        });
      },
      // 打开插播列表dialog
      handleOpenInsertFileDialog() {
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenInsertFileDialog'));
      },
      /**
       * 关闭插播
       * @param {Object} param0 isShowConfirmDialog 是否弹出确认关闭的弹窗
       */
      async closeInsertvideo(
        options = {
          isShowConfirmDialog: false
        }
      ) {
        window.vhallReportForProduct?.toStartReporting(110203, [110206, 110209, 110207], {
          evt_tp: options.type,
          file_info: ''
        });
        console.log('----关闭插播----', options.isShowConfirmDialog, options.type);
        // 如果不需要展示确认关闭按钮
        if (!options.isShowConfirmDialog) {
          await this.closeInsertvideoHandler();
          setTimeout(() => {
            this.clearCache();
          }, 1000);
          return;
        }
        // 关闭插播的时候如果处于全屏状态，退出全屏
        if (this.isFullScreen) {
          this.exitFullScreen();
        }
        window.vhallReportForProduct?.toResultsReporting(110206, {
          event_type: 'static',
          file_info: ''
        });
        this.$vhConfirm(this.$t('host.k_545022'), this.$t('host.k_545011'), {
          confirmButtonText: this.$t('host.k_545014'),
          cancelButtonText: this.$t('host.k_545023'),
          roundButton: true
        })
          .then(() => {
            window.vhallReportForProduct?.toResultsReporting(110209, {
              event_type: 'static',
              file_info: ''
            });
            // 关闭插播列表弹窗
            window.$middleEventSdk?.event?.send(
              boxEventOpitons(this.cuid, 'emitCloseInsertFileDialog')
            );
            this.closeInsertvideoHandler();
          })
          .catch(() => {
            window.vhallReportForProduct?.toResultsReporting(110207, {
              event_type: 'static',
              file_info: ''
            });
          })
          .finally(e => {
            //关闭插播清空插播缓存
            console.log('关闭插播清空插播缓存');
            setTimeout(() => {
              this.clearCache();
            }, 1000);
          });
      },
      // 关闭插播，还原插播状态 isliveStart 是否是开始直播调用的关闭插播的方法
      // 如果是开始直播触发的关闭插播,不需要更改对端的麦克风状态
      closeInsertvideoHandler(isliveStart) {
        // const interactiveServer = useInteractiveServer();
        if (this.conctorObj.statePlay) {
          // 如果不是暂停状态，关闭插播时会触发暂停事件，记录这个状态，暂停事件不需要发自定义消息
          this._isCloseInsertvideoHandler = true;
        }
        // 设置插播状态为 false
        // this.insertFileServer.setInsertFilePushing(false);
        window.vhallReportForProduct.toStartReporting(110210, 110211);
        return this.stopPushStream().then(res => {
          window.vhallReportForProduct.toResultsReporting(110211, {
            request_id: res?.request_id,
            event_type: 'interface',
            res: res
          });
          console.log('---插播流停止成功----');
          // 还原插播状态
          this.insertFileServer.clearInsertFileInfo();
          // 设置流为小屏
          this.roomBaseServer.setChangeElement('stream-list');
          document.getElementById('vmp-insert-stream-video').innerHTML = '';
          // 云插播播放器销毁
          this.$refs.insertStream && this.$refs.insertStream.destroy();
          // 本地插播播放器销毁
          this.$refs.localStreamRef.innerHTML = '';
          // 云插播播放器容器销毁
          this.insertFileServer.setInsertFileType('');
          // 插播隐藏
          this.insertFileStreamVisible = false;
          if (isliveStart) return;
          // 更改麦克风状态
          this.insertFileServer.updateMicMuteStatusByInsert({ isStart: false });
          // 设置旁路观看端大小屏
          this.setDesktop('0');
        });
      },
      // 销毁插播流
      stopPushStream(options = { isNotClearInsertFileInfo: false }) {
        if (!this.insertFileServer.state.insertStreamInfo.streamId) {
          return Promise.resolve();
        }
        // 停止推流
        return this.insertFileServer
          .stopPublishInsertStream(this.insertFileServer.state.insertStreamInfo.streamId, {
            isNotClearInsertFileInfo: options.isNotClearInsertFileInfo
          })
          .catch(e => {
            console.log('销毁本地插播流失败', e);
            return e;
          });
      },
      // 初始化云插播
      async initRemoteInsertFile() {
        if (this.insertFileServer.state.insertStreamInfo.streamId) {
          await this.stopPushStream();
          const el = document.getElementById('vmp-insert-stream-video');
          el.innerHTML = '';
        }
        if (this.$refs.insertStream) {
          this.$refs.insertStream && this.$refs.insertStream.destroy();
          this.$refs.insertStream.initPlayer();
        }
        // 关闭插播列表弹窗
        window.$middleEventSdk?.event?.send(
          boxEventOpitons(this.cuid, 'emitCloseInsertFileDialog')
        );
      },
      remoteInsertSuccess(videEl) {
        console.log(videEl, '点播初始化成功');
        // 隐藏分组设置
        const groupServer = useGroupServer();
        groupServer.state.panelShow = false;

        this.insertFileServer.setInsertVideoElement(videEl);
        // 设置插播画面在大窗,文档在小窗
        this.roomBaseServer.setChangeElement('doc');
        this.pushLocalStream();
      },
      // 注册事件监听
      initEventListener() {
        const groupServer = useGroupServer();
        if (this.insertFileServer.state.insertStreamInfo.streamId) {
          this.subscribeInsert();
        }

        // this.insertFileServer.$on('insert_mic_mute_change', status => {
        //   if (status == 'play') {
        //     this.$message.warning(this.$t('interact.interact_1026'));
        //   } else {
        //     this.$message.warning('麦克风开启，对方将听到您的声音');
        //   }
        // });

        this.addSDKEvents();
        // 注册发起端独有的事件
        if (this.roomBaseServer.state.watchInitData.join_info.role_name != 2) {
          const micServer = useMicServer();
          this.interactiveServer.$on('live_start', () => {
            this.closeInsertvideoHandler(true);
          });
          this.interactiveServer.$on('live_over', () => {
            this.insertFileStreamVisible && this.closeInsertvideoHandler();
            //结束直播清空插播缓存
            console.log('结束直播清空插播缓存');
            setTimeout(() => {
              this.clearCache();
            }, 1000);
          });
          // 有人开始演示，需要关闭插播
          groupServer.$on(groupServer.EVENT_TYPE.VRTC_CONNECT_PRESENTATION_SUCCESS, () => {
            if (this.isCurrentRoleInsert) {
              this.closeInsertvideoHandler();
            }
          });
          // 进入小组，需要关闭插播
          groupServer.$on(groupServer.EVENT_TYPE.ENTER_GROUP_FROM_MAIN, () => {
            if (this.isCurrentRoleInsert) {
              this.closeInsertvideoHandler();
            }
          });
          // 如果是拥有主讲人权限的嘉宾下麦，需要直接设置miniElement
          micServer.$on('vrtc_disconnect_success', () => {
            if (
              this.roomBaseServer.state.interactToolStatus.doc_permission ==
                this.roomBaseServer.state.watchInitData.join_info.third_party_user_id &&
              this.isCurrentRoleInsert
            ) {
              this.roomBaseServer.setChangeElement('stream-list');
            }
          });
        }

        /**
         *  监听退出全屏事件
         */
        window.addEventListener(
          'fullscreenchange',
          () => {
            if (document.fullscreenElement) {
              // 进入全屏
            } else {
              // 离开全屏
              this.isFullScreen = false;
            }
          },
          true
        );
      },
      handleScreenExchange() {
        console.log('max_min_screen_exchange trigger[insert-video-stream]');
        if (
          this.isWatch &&
          this.insertFileStreamVisible &&
          !['SplitScreen'].includes(this.$route.name) &&
          !this.isFullScreen &&
          this.docSwitchStatus
        ) {
          console.log('max_min_screen_exchange on: insert-video-stream');
          this.exchange();
        }
      },
      // 订阅插播流
      subscribeInsert() {
        //观众加载旁路播放器的情况下，不走订阅插播流
        console.log('subscribeInsert---', this.isPlayerInit);
        if (this.isPlayerInit) return;
        const opt = {
          videoNode: 'vmp-insert-subscribe-stream', // 远端流显示容器，必填
          mute: { audio: false, video: false } // 是否静音，关视频。选填 默认false
        };
        try {
          this.insertFileServer.subscribeInsertStream(opt).then(() => {
            // 展示插播流组件
            this.insertFileStreamVisible = true;
            // 如果不是观众(主持人\助理\嘉宾)
            if (this.roomBaseServer.state.watchInitData.join_info.role_name != 2) {
              // 设置 miniElement 为 doc
              this.roomBaseServer.setChangeElement('doc');
            } else {
              // 如果是观众
              // 如果文档可见
              if (this.docServer.state.switchStatus) {
                // 设置 miniElement 为主屏流
                this.roomBaseServer.setChangeElement('doc');
              } else {
                this.roomBaseServer.setChangeElement('');
              }
            }
          });
        } catch (error) {
          console.log('error', error);
        }
      },
      // 取消订阅插播流
      unsubscribeInsert() {
        // 观众加载旁路播放器的情况下，不走取消订阅插播流
        console.log('unsubscribeInsert---', this.isPlayerInit);
        if (this.isPlayerInit) return;
        // 隐藏插播流组件
        this.insertFileStreamVisible = false;
        // 如果不是观众(主持人\助理\嘉宾)
        if (this.roomBaseServer.state.watchInitData.join_info.role_name != 2) {
          // 设置 miniElement 为 stream-list
          this.roomBaseServer.setChangeElement('stream-list');
        } else {
          // 如果是观众
          // 设置 miniElement 为主屏流
          if (this.docServer.state.switchStatus) {
            this.roomBaseServer.setChangeElement('stream-list');
          } else {
            this.roomBaseServer.setChangeElement('');
          }
        }
        this.insertFileServer.clearInsertFileInfo();
      },
      // 添加互动sdk事件
      addSDKEvents() {
        // 流加入
        this.insertFileServer.$on('INSERT_FILE_STREAM_ADD', () => {
          console.log('%c[pc]互动sdk 监听插播流加入处理', 'color:red');
          this.subscribeInsert();
        });

        // 插播流删除
        this.insertFileServer.$on('INSERT_FILE_STREAM_REMOVE', () => {
          console.log('%c[pc]互动sdk 监听插播流离开处理', 'color:red');
          this.unsubscribeInsert();
        });

        // 订阅失败
        this.insertFileServer.$on('INSERT_FILE_STREAM_FAILED', () => {
          this.subscribeInsert();
        });

        useMsgServer().$onMsg('ROOM_MSG', msg => {
          const accountId = useRoomBaseServer().state.watchInitData.join_info.third_party_user_id;
          // 主画面变更
          if (msg.data.type == 'vrtc_big_screen_set') {
            // 自己正在发起桌面共享
            if (this.isCurrentRoleInsert && msg.data.target_id != accountId) {
              this.closeInsertvideoHandler();
            }
          }
        });
      },
      // 鼠标移出隐藏播放器控制栏
      wrapLeave() {
        // console.log('----wrapLeave-=----');
        this._timers = setTimeout(() => {
          // console.log('----wrapLeave-setTimeout=----');
          this.constrolUp = false;
          clearTimeout(this._timers);
          this.$refs.insertStream && this.$refs.insertStream.wrapLeave();
        }, 3000);
      },
      // 鼠标移入显示播放器控制栏
      wrapHover() {
        // console.log('----wrapHover-=----');
        clearTimeout(this._timers);
        this.constrolUp = true;
        this.$refs.insertStream && this.$refs.insertStream.wrapEnter();
      },
      // 隐藏控制栏
      hideInsertVideoControl() {
        this.constrolUp = false;
      },
      // 初始化本地插播进度条的事件
      initSlider() {
        this.conctorObj.sliderVal = 0;
        const tol = (this.conctorObj.totalTime = this._localFileVideoElement.duration);
        this.conctorObj.currentTime = 0;
        this._localFileVideoElement.addEventListener('timeupdate', () => {
          const cur = (this.conctorObj.currentTime = this._localFileVideoElement.currentTime);
          this.conctorObj.sliderVal = (cur / tol) * 100;
        });
        // 拖拽显示时间
        const dom = this.$refs.controllerRef.$el;
        const but = document.querySelector(
          '.vmp-insert-stream-controller-slider .vh-slider__button-wrapper'
        );
        const innitDom = () => {
          dom.onmouseover = e => {
            // console.log('dom over', e);
            this.conctorObj.TimesShow = true;
            const totalWidth = (this.ContorlWidth = dom.offsetWidth);
            const lef = e.layerX;
            this.conctorObj.hoverTime = (lef / totalWidth) * tol;
            this.conctorObj.hoverLeft = lef;
            dom.onmousemove = event => {
              const lef = event.layerX;
              this.conctorObj.hoverTime = (lef / totalWidth) * tol;
              this.conctorObj.hoverLeft = lef;
            };
          };
          // eslint-disable-next-line no-unused-vars
          dom.onmouseout = e => {
            this.conctorObj.TimesShow = false;
          };
        };
        innitDom();
        // eslint-disable-next-line no-unused-vars
        but.onmousedown = e => {
          dom.onmouseout = dom.onmousemove = dom.onmousemove = dom.onmouseover = null;
          this.ContorlWidth = dom.offsetWidth;
          this.onmousedownControl = true;
          this.pause();
          // eslint-disable-next-line no-unused-vars
          this._handleDocumentMouseMove = () => {
            console.log('----insertfile----this----', this);
            this.conctorObj.TimesShow = true;
          };
          this._handleDocumentMouseUp = () => {
            console.log('----insertfile----this----', this);
            document.removeEventListener('mousemove', this._handleDocumentMouseMove);
            document.removeEventListener('mouseup', this._handleDocumentMouseUp);
            this.onmousedownControl = false;
            this.conctorObj.TimesShow = false;
            innitDom();
          };
          document.addEventListener('mousemove', this._handleDocumentMouseMove);
          // eslint-disable-next-line no-unused-vars
          document.addEventListener('mouseup', this._handleDocumentMouseUp);
        };
        but.onmouseover = e => {
          this.conctorObj.TimesShow = false;
          e.stopPropagation();
        };
      },
      // 本地插播设置video音量
      setVoice(val) {
        const vo = val / 100;
        if (this._localFileVideoElement) {
          if (val <= 0.01) {
            this._localFileVideoElement.volume = 0.01;
          } else {
            this._localFileVideoElement.volume = vo;
          }
        }
      },
      // 本地插播video开始\暂停
      videoPlayBtn() {
        const ispaused = this._localFileVideoElement.paused;
        if (ispaused) {
          this.play();
        } else {
          this.pause();
        }
        window.vhallReportForProduct.toReport(110212, {
          report_extra: {
            type: 'localInsert',
            file_info: '',
            pre_status: ispaused ? 'pause' : 'playing',
            after_atatus: ispaused ? 'playing' : 'pause'
          }
        });
      },
      // 大小窗切换
      exchange() {
        let miniElement;
        if (this.isWatch) {
          if (this.isAudio) {
            miniElement =
              this.miniElement == 'insert-video' || this.miniElement == 'stream-list'
                ? 'doc'
                : 'stream-list';
          } else {
            miniElement = this.miniElement == 'insert-video' ? 'doc' : 'insert-video';
          }
        } else {
          miniElement = this.miniElement == 'insert-video' ? 'doc' : 'insert-video';
        }
        this.roomBaseServer.setChangeElement(miniElement);

        window.vhallReportForProduct?.report(110135);
      },
      // video静音
      videoMute() {
        const vo = this._localFileVideoElement && this._localFileVideoElement.volume;
        if (vo) {
          if (vo > 0.01) {
            this._cacheVolume = vo;
            this._localFileVideoElement.volume = 0;
            this.voice = 0;
          } else {
            this._localFileVideoElement.volume = this._cacheVolume;
            this.voice = this._cacheVolume * 100;
          }
        }
      },
      // 设置video的currentTime
      setVideoCurrentTime() {
        // 快进功能
        const time = (this.conctorObj.sliderVal / 100) * this.conctorObj.totalTime;
        console.log(this.conctorObj.sliderVal, '快进');
        this._localFileVideoElement.currentTime = time;
        this.play();
        window.vhallReportForProduct?.toStartReporting(110213, 110213, {
          currentTime: time
        });
      },
      // 本地插播video暂停
      pause() {
        this._localFileVideoElement && this._localFileVideoElement.pause();
      },
      // 本地插播video开始
      play() {
        this._localFileVideoElement && this._localFileVideoElement.play();
        this.conctorObj.statePlay = true;
      },
      // 全屏
      enterFullScreen() {
        this.isFullScreen = true;
        const fullarea = this.$refs.insertWrapRef;
        if (fullarea.requestFullscreen) {
          fullarea.requestFullscreen();
        } else if (fullarea.webkitRequestFullScreen) {
          fullarea.webkitRequestFullScreen();
        } else if (fullarea.mozRequestFullScreen) {
          fullarea.mozRequestFullScreen();
        } else if (fullarea.msRequestFullscreen) {
          // IE11
          fullarea.msRequestFullscreen();
        }
      },
      // 取消全屏
      exitFullScreen() {
        this.isFullScreen = false;
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      },
      // 开始插播开启并且白板或者文档观众可见状态时观看端视频最大化
      setDesktop(status) {
        if (useDocServer().state.switchStatus) {
          this.interactiveServer.setDesktop({ status });
        }
      },
      insertVideoEnd(type) {
        //播放结束 抛出消息
        window.$middleEventSdk?.event?.send(
          boxEventOpitons(this.cuid, 'emitInsertVideoEnd', [
            {
              insertPlayType: type,
              ...this.curInsertParams
            }
          ])
        );
      },
      handleCommand(command) {
        this.curInsertPlayType = command;
        // 已废弃
        // window.$middleEventSdk?.event?.send(
        //   boxEventOpitons(this.cuid, 'emitChangeInsertVideoType', [command])
        // );
      },
      //清除插播文件存储
      clearCache() {
        const { watchInitData } = useRoomBaseServer().state;
        let arr = [];
        let inserts = sessionStorage.getItem('insertCache');
        if (inserts) {
          arr = JSON.parse(inserts);
          for (let i = 0; i < arr.length; i++) {
            const element = arr[i];
            if (element.webinar_id == watchInitData.webinar.id) {
              arr.splice(i, 1);
            }
          }
        }
        sessionStorage.setItem('insertCache', JSON.stringify(arr));
      }
    }
  };
</script>
<style lang="less">
  .vmp-insert-stream {
    width: 100%;
    height: 100%;
    position: relative;
    &__h0 {
      height: 0;
      overflow: hidden;
    }
    &__mini {
      width: 309px;
      height: 240px;
      top: 0;
      right: 0;
      z-index: 10;
      position: absolute;
      overflow: hidden;
    }
    &__is-watch {
      position: absolute;
      top: 0;
      bottom: 56px;
      width: calc(100% - 380px);
      height: auto;
      min-height: auto;
      &.vmp-insert-stream__mini {
        width: 360px;
        height: 204px;
        min-height: 204px;
        top: 0 !important;
        right: 0;
        z-index: 11;
        overflow: hidden;
      }
    }
    &__is-embed {
      width: calc(100% - 360px);
    }
    &__has-stream-list {
      top: 80px;
    }
    &__is-watch-full-screen {
      .vmp-insert-stream-mask {
        height: 25px;
        bottom: 16px;
        top: auto;
        opacity: 1;
        background: none;
      }
      .vmp-insert-stream-mask__label {
        display: none;
      }
    }
    .vmp-insert-local-stream {
      position: absolute;
      height: 100px;
      width: 100px;
      display: none;
    }
    .vmp-insert-remote-stream {
      position: absolute;
      height: 100%;
      width: 100%;
    }
    .vmp-insert-stream-video {
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0px;
      top: 0px;
      background-color: #2d2d2d;
    }
    .vmp-insert-stream-audio-poster {
      width: 100%;
      height: 100%;
      object-fit: cover;
      background-image: url(./img/video.gif);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    .vmp-insert-subscribe-stream {
      width: 100%;
      height: 100%;
    }
    &-mask {
      opacity: 0;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.7);
      z-index: 5;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        opacity: 1;
      }
      p {
        width: 100%;
        color: #fff;
        text-align: center;
      }
      span {
        display: inline-block;
        text-align: right;
        width: 54px;
        margin-right: 10px;
        font-size: 12px;
      }
      a {
        display: inline-block;
        color: #fff;
        font-size: 16px;
        width: 32px;
        height: 32px;
        line-height: 32px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 100%;
        margin-right: 10px;
        &:hover {
          background: #fb3a32;
        }
        &.iconsheweizhujiangren {
          font-size: 14px;
        }
      }
    }
    &-controller {
      position: absolute;
      bottom: -31px;
      z-index: 6;
      width: 100%;
      padding: 0px 0 0 23px;
      height: 38px;
      box-sizing: border-box;
      background: rgba(26, 26, 26, 0.7);
      transition: all 0.8s;
      &.insert-active-top {
        bottom: 0px;
      }
      &-slider {
        position: absolute;
        width: 100%;
        height: 4px;
        background-color: rgba(255, 255, 255, 0.2);
        left: 0px;
        top: -8px;
        &:hover {
          height: 8px;
          top: -8px;
          .vh-slider .vh-slider__runway {
            height: 8px;
            .vh-slider__bar {
              height: 8px;
            }
            .vh-slider__button-wrapper {
              top: -14px;
            }
          }
        }
        .vh-slider {
          .vh-slider__runway {
            margin: 0;
            height: 3px;
            background-color: rgba(255, 255, 255, 0.3);
          }
        }
        .vh-slider__button-wrapper {
          top: -16px;
        }
        .vh-slider__bar {
          height: 3px;
          background-color: #fb3a32;
        }
        .vh-slider__button {
          width: 10px;
          height: 10px;
          border-color: #fb3a32;
        }
        &-times {
          position: absolute;
          top: -35px;
          text-align: center;
          padding: 5px;
          background: rgba(0, 0, 0, 0.3);
          font-size: 12px;
          color: #fff;
          transform: translateX(-50%);
        }
      }
      &-wrap {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        &-left {
          height: 38px;
          line-height: 38px;
          i {
            color: #fff;
            display: inline-block;
            cursor: pointer;
            font-size: 16px;
            text-align: center;
            position: relative;
          }
          .vmp-insert-time {
            display: inline-block;
            line-height: 48px;
            color: #fff;
            padding-left: 5px;
          }
        }
        &-right {
          color: #fff;
          i:last-child {
            padding: 0 12px;
            cursor: pointer;
          }
          .vmp-volume-box {
            display: inline-block;
            line-height: 34px;
            position: relative;
            height: 34px;
            margin-top: 6px;
            &:hover {
              .vmp-ver-slider {
                display: block;
              }
            }
            .vmp-icon-box {
              i {
                padding-right: 5px;
                cursor: pointer;
              }
            }
            .vmp-ver-slider {
              display: none;
              position: absolute;
              left: 16px;
              bottom: 32px;
              .vh-slider {
                .vh-slider__runway {
                  margin: 0;
                  height: 3px;
                  background-color: rgba(255, 255, 255, 0.3);
                }
              }
              .vh-slider__bar {
                height: 3px;
                background-color: #fb3a32;
              }
              .vh-slider__button {
                width: 10px;
                height: 10px;
                border-color: #fb3a32;
              }
            }
          }

          .vh-dropdown-link,
          .vh-line-menu,
          .vh-line-close {
            margin-left: 12px;
          }
          .vh-iconfont,
          .iconfont-v3 {
            cursor: pointer;
            &:hover {
              color: #fb3a32;
            }
          }
          .iconfont-v3 {
            font-size: 18px;
          }
          .vh-dropdown {
            color: #fff;
          }
        }
      }
    }
  }
  .dropdownVideo {
    background-color: rgba(0, 0, 0, 0.7) !important;
    .vh-dropdown-menu__item {
      color: #fff;
      &:not(.is-disabled):hover {
        color: var(--theme-color-main);
        background: transparent;
      }
    }
  }
  .insertDropdownVideo {
    .vh-dropdown-menu__item {
      font-size: 12px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      span {
        margin-right: 4px;
      }
    }
  }
</style>
